export default __webpack_public_path__ + "static/media/cart.8a0e978f.svg";